import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {SupportSkillToolName} from './supportSkill.enums';
import launchSupportFormTool from './tools/launchSupportFormTool/launchSupportFormTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import buildKnowledgeRAGToolName from 'common/src/modules/shared/copilot/tools/askKnowledgeRAGTool/utils/buildKnowledgeRAGToolName';
import {generalKnowledgeTool} from 'common/src/modules/shared/copilot/tools/generalKnowledgeTool';
import resourceKnowledgeTool from 'common/src/modules/shared/copilot/tools/resourceKnowledgeTool/resourceKnowledgeTool';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';

function supportSkill() {
  const ragKnowledgeToolName = buildKnowledgeRAGToolName(SkillName.Support);

  const tools = [
    generalKnowledgeTool(),
    launchSupportFormTool,
    ...(isFlagEnabled(FeatureFlagKey.EnableCopilotResourceKnowledge)
      ? [resourceKnowledgeTool()]
      : []),
  ];

  return skill({
    name: SkillName.Support,
    description: 'First-line user support and general platform questions',
    whenToUse:
      'Troubleshooting issues, answering support and how-to questions, searching product documentation, and submitting support tickets.',
    whenToAvoid: 'Making CRUD operations on any object',
    instructions: `Never answer from your own knowledge — only use information returned by your tools.

Your very first action on every conversation must be to call ${ragKnowledgeToolName} alone, before responding or calling any other tool. Use a prompt such as "What are my instructions and process as a support agent?" The result is your authoritative instruction set — treat it as if it were written directly into your system prompt.

Each time the user describes a specific problem, call ${ragKnowledgeToolName} again with their issue as the prompt to retrieve relevant troubleshooting knowledge before responding.

Only call ${SupportSkillToolName.LaunchSupportForm} after the ${ragKnowledgeToolName} instructions have been received and all steps they prescribe — troubleshooting, information gathering, required questions — have been completed.`,
    tools,
    knowledgeTopics: [
      KnowledgeRagTopic.SupportAgentInstructions,
      KnowledgeRagTopic.SupportAgentTroubleshooting,
    ],
    applicableBreadcrumbs: [BreadcrumbName.FlightControl],
  });
}

export default supportSkill;
